import { type FC } from "react"
import styled from "styled-components"

import CookiePolicy from "~/components/CookiePolicy"
import Layout from "~/themes/original/components/Layout"

const CookiePolicyPage: FC = () => (
	<Layout>
		<Title>Cookie Policy</Title>
		<Content>
			<CookiePolicy />
		</Content>
	</Layout>
)

const Title = styled.h1`
	font-weight: 500;
	font-size: 36px;
	color: #151d48;
	margin-bottom: 24px;

	@media (max-width: 999px) {
		margin-left: 16px;
		margin-right: 16px;
	}
`

const Content = styled.div`
	h2 {
		font-weight: 600;
		font-size: 20px;
		color: #151d48;
		margin-bottom: 8px;
	}

	p {
		font-size: 14px;
		margin-bottom: 16px;
	}

	ul,
	ol {
		margin: 0 0 16px 16px;
	}

	table {
		width: 100%;
		border-collapse: collapse;
		border: 1px solid #ddd;
		margin-bottom: 16px;
	}

	table th,
	table td {
		padding: 8px;
	}
`

export default CookiePolicyPage
